import ReactDOM from 'react-dom'
// Redux
// https://github.com/rt2zz/redux-persist
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import * as _redux from './setup'
import store, { persistor } from './setup/redux/Store'
// Axios
import axios from 'axios'
import { Chart, registerables } from 'chart.js'

// Apps
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import { AppRoutes } from './app/routing/AppRoutes'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
import "@fontsource/inter";
import '@fontsource/roboto'; // Import semua berat (weight)
import "@fontsource/roboto-condensed";
import { GoogleOAuthProvider } from '@react-oauth/google'
import { SWRConfig, SWRConfiguration } from 'swr'

// import moments from 'moment';

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.setupAxios(axios, store)

Chart.register(...registerables)

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const globalSWRConfig: SWRConfiguration = {
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        // ❌ Stop retry kalau error 4xx (client error)
        // if (error?.status >= 400 && error?.status < 500) return;

        // ❌ Stop retry kalau sudah 3x
        if (retryCount >= 3) return;

        // ✅ Retry lagi setelah 5 detik
        setTimeout(() => revalidate({ retryCount }), 5000);
    },
    errorRetryCount: 3, // limit global
};

ReactDOM.render(
  <MetronicI18nProvider>
    <Provider store={store}>
      <SWRConfig value={globalSWRConfig}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID || ''}>
          {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
          <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
            <AppRoutes />
          </PersistGate>
        </GoogleOAuthProvider>
      </SWRConfig>
    </Provider>
  </MetronicI18nProvider>,
  document.getElementById('root')
)
